<template>
  <form @submit.prevent="view">
    <h1 class="text-danger">{{ $t("global.warning") }}!</h1>
    <div class="text-secondary">{{ $t("global.password-view-warning") }}</div>
    <hr />
    <div class="text-primary mt-3">{{ $t("global.shared-on") }}: {{ expirationDate() }}</div>
    <div class="text-danger mt-3">{{ $t("global.expires-on") }}: {{ sharedDate() }}</div>
    <div v-if="service" class="text-primary mt-3">{{ $t("global.service") }}: {{ service }}</div>
    <hr />
    <h3 class="text-primary mt-3">{{ $t("global.views-remaining") }}: {{ remainingViews() }}</h3>
    <div v-if="passwordValue" class="mt-4 h3">
      <span class="text-primary">{{ $t("global.your-password-is") }}:</span>
      <span class="mx-2 text-danger">
        <u>{{ passwordValue }}</u>
      </span>
      <CopyToClipboard :text="passwordValue" />
    </div>
    <div class="mt-5 text-right">
      <Btn class="mr-2" variant="light" type="button" :disabled="loading" @click="close">
        {{ $t("global.close") }}
      </Btn>
      <Btn
        variant="primary"
        @click="view"
        :loading="loading"
        :disabled="viewed"
        data-test="view-password-button"
      >
        {{ $t("global.view-password") }}
      </Btn>
    </div>
  </form>
</template>

<script>
import { reactive, ref } from "@vue/composition-api";
import Btn from "@/components/display/Btn";
import CopyToClipboard from "@/components/display/CopyToClipboard";
import { dateFormat } from "leatherman-js/utils/formatters/time";
import store from "@/store";

export default {
  name: "ViewPasswordForm",
  props: {
    password: {
      type: Object,
      required: true,
    },
    service: {
      type: String,
      required: false,
    },
  },
  components: {
    Btn,
    CopyToClipboard,
  },
  setup(props, { emit }) {
    const loading = ref(false);
    // data about the password
    const passwordData = reactive({ ...props.password });
    // the actual protected value of the password
    const passwordValue = ref(null);
    const viewed = ref(false);
    const remainingViews = () => passwordData.maxViews - passwordData.views;
    const expirationDate = () => dateFormat(passwordData.sharedDate, true);
    const sharedDate = () => dateFormat(passwordData.expirationDate, true);
    const close = () => emit("close");

    const view = () => {
      loading.value = true;

      store
        .dispatch("password/get", passwordData.id)
        .then((password) => {
          // display password on the page
          passwordValue.value = password;
          // update the now incremented views field
          // api reponse only shows previous value (which is why here it is manually incrementing up)
          passwordData.views = passwordData.views + 1;
          // show the new shared date (now)
          passwordData.sharedDate = Date.now() / 1000;
          viewed.value = true;
        })
        .finally(() => {
          loading.value = false;
        });
    };

    return {
      close,
      loading,
      passwordValue,
      view,
      viewed,
      remainingViews,
      expirationDate,
      sharedDate,
      dateFormat,
    };
  },
};
</script>

<style lang="scss" scoped></style>
